import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { sortBy, without } from 'lodash';
import { useTranslation } from 'next-i18next';
import trustYouLogo from '../../../../../../assets/images/hotelDetailsOverlay/trust-you-logo.png';
import { Header } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/Summary/components/Header.js';
import { useRating } from '../../../../../../components/HotelDetailsOverlay/hooks/useRating.js';
import { REVIEW_CATEGORY_LOCATION, REVIEW_CATEGORY_ROOM, REVIEW_CATEGORY_SERVICE } from '../../../../../../components/HotelDetailsOverlay/models.js';
import { NextImage } from '../../../../../../components/internal/NextImage/index.js';
import { HeadlineLarge, HelpTooltip, RatingBadge, RatingSummary, Stack } from '../../../../../../primitives/index.js';
import { HOTEL_DETAILS_QA_ID, qaId } from '../../../../../../utils/qaId.js';
const PREFERRED_REVIEW_CATEGORIES = [REVIEW_CATEGORY_ROOM, REVIEW_CATEGORY_LOCATION, REVIEW_CATEGORY_SERVICE];
const MAX_REVIEW_CATEGORIES_TO_SHOW = 3;
export const Summary = ({
  score,
  scoreDescription,
  reviewsCount,
  reviewCategories: allReviewCategories = []
}) => {
  const {
    t
  } = useTranslation();
  const formatScore = useRating();
  const preferredReviewCategories = sortBy(allReviewCategories.filter(({
    id
  }) => PREFERRED_REVIEW_CATEGORIES.includes(id)), ({
    id
  }) => PREFERRED_REVIEW_CATEGORIES.indexOf(id));
  const reviewCategories = preferredReviewCategories.concat(without(allReviewCategories, ...preferredReviewCategories)).slice(0, MAX_REVIEW_CATEGORIES_TO_SHOW);
  const {
    scoreFormatted,
    scoreMax,
    sentiment
  } = formatScore(score);
  return _jsxs(Stack, {
    children: [_jsxs(Header, {
      children: [_jsx(HeadlineLarge, {
        "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'ratingsection-headline'),
        children: t('hotelDetailsOverlay:ratingSection.summary.title')
      }), _jsx(NextImage, {
        image: trustYouLogo,
        width: 69,
        height: 28,
        alt: ""
      }), _jsx(HelpTooltip, {
        placement: "bottom",
        content: t('hotelDetailsOverlay:ratingSection.summary.tooltip')
      })]
    }), _jsx(RatingSummary, {
      sentiment: sentiment,
      badge: _jsxs(RatingBadge, {
        variant: "vertical",
        sentiment: sentiment,
        size: "large",
        children: [scoreFormatted, " / ", scoreMax]
      }),
      title: _jsxs(_Fragment, {
        children: [t('hotelDetailsOverlay:ratingSection.summary.overallRating') + ': ', _jsx("span", {
          children: scoreDescription
        })]
      }),
      subtitle: t('hotelDetailsOverlay:ratingSection.xReviews', {
        count: reviewsCount
      }),
      categories: reviewCategories.map(category => ({
        name: category.caption,
        value: formatScore(category.score).scoreFormatted
      }))
    })]
  });
};